import Vue from 'vue'
import { createApp } from 'vue'
import ElementPlus from 'element-plus'
import zhCn from 'element-plus/es/locale/lang/zh-cn'
import 'element-plus/dist/index.css'
import qs from 'qs'
// import axios from 'axios';
import axios from './axios.js'
import VueAxios from 'vue-axios'
import reqURL from './utils/urls.js'
import store from './utils/store.js'
import App from './App.vue'
import { i18n } from './i18n'
import { router } from './route/index'

import DyForm from '@/components/common/DyForm.vue'
import DyTable from '@/components/common/DyTable.vue'



const app = createApp(App)
app.config.globalProperties.$http = axios;
app.config.globalProperties.$reqURL = reqURL;
app.config.globalProperties.$store = store;
app.config.globalProperties.$qs = qs;
app.use(store)
app.use(i18n)
app.use(router)
app.use(ElementPlus, { locale: zhCn })
app.use(VueAxios, axios)

app.component('DyForm', DyForm);
app.component('DyTable', DyTable);

(function suppressROErrors() {
    if (!window.__resizeObserverSuppressed__) {
      const origConsoleError = console.error;
      const origRO = window.ResizeObserver;
      
      console.error = function(...args) {
        if (/ResizeObserver/.test(args[0])) return;
        origConsoleError.apply(console, args);
      };
      
      window.ResizeObserver = class extends (origRO || class {}) {
        observe() {}  // 空实现
        disconnect() {}
      };
      
      window.__resizeObserverSuppressed__ = true;
    }
  })();

app.mount('#app')
